import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { UPDATE_WAREHOUSE } from "../warehouse.queries";
import { parseParams } from "../../../helpers/clean-object";

import { UpdateWarehouseInput } from "../../../__generated__/globalTypes";
import {
  UpdateWarehouseMutation,
  UpdateWarehouseMutationVariables,
} from "../../../__generated__/UpdateWarehouseMutation";

interface IProps {
  id: number;
  onCompleted: () => any;
}

export const useUpdateWarehouse = ({ id, onCompleted }: IProps) => {
  const form = useForm<UpdateWarehouseInput>({
    mode: "all",
  });
  const [mutate, { loading }] = useMutation<
    UpdateWarehouseMutation,
    UpdateWarehouseMutationVariables
  >(UPDATE_WAREHOUSE, {
    refetchQueries: "active",
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          id,
          input: parseParams(input),
        },
      });

      if (data?.updateWarehouse?.ok) {
        onCompleted();
      } else {
        throw Error(data?.updateWarehouse?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
